<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" color="primary" class="ml-3">
        <span v-if="edit === false">Criar Solução</span>
        <span v-else>Editar Solução</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <span v-if="edit === false">Criar Solução</span>
            <span v-else>Editar Solução</span>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col>
              <v-text-field
                label="Solução"
                name="nome"
                type="text"
                required
                v-model="payload.nome"
                :rules="[obrigatorio]"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ComboboxGroupSolution
                ref="grupoSolution"
                :filter="{
                  grupoSolucaoId: atualGrupoSolucao,
                }"
                :groupSolutionId="atualGrupoSolucao"
                :title="'Eixos'"
                :rules="[obrigatorio]"
                multiple
                @changeGroupSolution="(e) => (atualGrupoSolucao = e)"
              ></ComboboxGroupSolution>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                label="Subsídio"
                name="subsidio"
                type="number"
                required
                v-model="payload.subsidio"
                :rules="[obrigatorio]"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-currency-field
                label="Preço"
                :prefix="'R$'"
                filled
                v-model="payload.preco"
                :rules="[obrigatorio]"
                hide-details="auto"
              />
            </v-col>
            <v-col>
              <v-currency-field
                label="Custo"
                :prefix="'R$'"
                filled
                v-model="payload.custo"
                :rules="[obrigatorio]"
                hide-details="auto"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div>Contrapartida Sebrae</div>
              {{
                valorSebrae().toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}
            </v-col>
            <v-col>
              <div>Investimento Município</div>
              {{
                valorMunicipio().toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="payload.dataInicio"
                v-mascara="'##/##/####'"
                label="Data Início Padrão"
                placeholder="00/00/0000"
                hide-details="auto"
                :rules="rulesData"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="payload.dataFim"
                v-mascara="'##/##/####'"
                label="Data Final Padrão"
                placeholder="00/00/0000"
                hide-details="auto"
                :rules="rulesData"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                label="Descrição"
                v-model="payload.descricao"
                hide-details="auto"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="close()">Fechar</v-btn>
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ComboboxGroupSolution from "@/modules/group-solution/components/Combobox.vue";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";

import { dataRegexValidatior } from "@/helpers/validator";
import { municipioPropostaSolucaoExtraApi } from "@/apis/proposta";

export default {
  name: "ModalInsertSolucoesExtras",
  props: {
    object: { type: Object, required: false },
    edit: { type: Boolean, required: false, default: false },
  },
  components: {
    ComboboxGroupSolution,
  },
  computed: {
    ...mapGetters(["user"]),
  },
  data() {
    return {
      uf: this.$store.state.uf,
      payload: {
        dataInicio: "01/04/2025",
        dataFim: "31/12/2026",
      },
      obrigatorio: (v) => !!v || "Campo Obrigatório",
      dialog: false,
      atualGrupoSolucao: null,
      municipioId: this.$route.params.id,

      rulesData: [
        (v) => {
          if (!v) return true;
          if (!dataRegexValidatior.test(v)) {
            return "Data inválida";
          }
          return true;
        },
      ],
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        if (this.object && this.edit === true) {
          this.payload = {
            ...this.object,
            dataInicio: moment(this.object.dataInicio).format("DD/MM/YYYY"),
            dataFim: moment(this.object.dataFim).format("DD/MM/YYYY"),
          };

          this.atualGrupoSolucao = this.object.grupoSolucaoId;
        } else {
          this.payload = {
            dataInicio: "01/01/2025",
            dataFim: "31/12/2026",
          };
        }
      }
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    valorSebrae() {
      if (!this.payload.preco) return 0;
      return this.payload.preco * (this.payload.subsidio / 100);
    },
    valorMunicipio() {
      if (!this.payload.preco) return 0;
      return this.payload.preco * ((100 - this.payload.subsidio) / 100);
    },
    async check() {
      if (!this.$refs.form) return true;
      const isValid = await this.$refs.form.validate();
      const isValidGrupo = await this.$refs.grupoSolution.check();
      return isValid && isValidGrupo;
    },
    async onConfirm() {
      const valid = await this.check();
      if (!valid) return;
      this.setLoading(true);

      this.payload.dataFim = moment(this.payload.dataFim, "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      );
      this.payload.dataInicio = moment(
        this.payload.dataInicio,
        "DD/MM/YYYY"
      ).format("YYYY-MM-DD");

      this.payload.municipioId = this.municipioId;
      this.payload.grupoSolucaoId = this.atualGrupoSolucao;
      this.payload.valorSebrae = this.valorSebrae();
      this.payload.valorMunicipio = this.valorMunicipio();
      if (this.edit === true) {
        municipioPropostaSolucaoExtraApi
          .update(this.payload)
          .then((resp) => {
            this.dialog = false;
            this.$emit("load");
          })
          .catch();
        this.payload = {};
      } else {
        this.payload.usuarioCriacao = this.user.usuarioId;
        this.payload.dataCriacao = moment().format("YYYY-MM-DD");

        municipioPropostaSolucaoExtraApi
          .add(this.payload)
          .then((resp) => {
            this.dialog = false;
            this.$emit("load");
          })
          .catch();
        this.payload = {};
      }
    },
    close() {
      this.payload = {};
      this.dialog = false;
    },
  },
};
</script>
